import { Buttons, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { useTranslation } from 'Hooks/useTranslation';
import { routes } from 'Constants/routes';
import * as Styled from './styles';
import { PreviousYearsBannerProps } from './types';

const PreviousYearsBanner = ({
  tinyButtonClick,
  isResult,
}: PreviousYearsBannerProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);

  return (
    <Styled.Container
      direction="column"
      gap="dimension_08"
      align="center"
      justify="center"
      isResult
    >
      <Text type="paragraphs" size="L_L_S" color="dark" align="center">
        {t('PreviousYear.banner.title', { context: isResult && 'result' })}
      </Text>
      <Text type="paragraphs" size="S_S_S" color="dark" align="center">
        {t('PreviousYear.banner.subtitle', { context: isResult && 'result' })}
      </Text>
      <Buttons.Classic
        mode="success"
        size="m"
        label={t('PreviousYear.button', { context: isResult && 'result' })}
        onClick={() => history.push(routes.PREVIOUS_YEARS_INFO)}
      />
      {!isResult && <Buttons.Tiny label={t('PreviousYear.later')} onClick={tinyButtonClick} />}
    </Styled.Container>
  );
};

export default PreviousYearsBanner;
